/**
 * Olfactum — Mystery Box Quiz Personalizado
 * Alpine.js component: Alpine.data('mysteryQuiz')
 *
 * Flujo: landing → quiz (5 preguntas) → profile → select (cajas)
 * Las respuestas se envían como line item properties al agregar al carrito.
 * Incluye lógica de countdown y sticky CTA (antes en mbpPage).
 */

document.addEventListener('alpine:init', function() {
  Alpine.data('mysteryQuiz', function(config) {
    return {
      // ── Estado del quiz ──
      screen: 'landing',       // landing | quiz | profile | select
      currentStep: 0,
      answers: [],
      _stepChanging: false,

      questions: config.questions || [],
      boxes: config.boxes || [],

      // Perfil generado
      profile: {
        tags: [],
        exclusions: [],
        summary: '',
        style: '',
        occasion: '',
        projection: ''
      },

      // ── Estado de la página (ex-mbpPage) ──
      selected: null,
      sizeIdx: {},   // { boxId: selectedSizeIndex }
      stickyVisible: false,
      timer: '23:59:59',
      _tid: null,
      _obs: null,

      // ── Getters ──
      get totalSteps() {
        return this.questions.length;
      },

      get currentQuestion() {
        if (this._stepChanging) return null;
        return this.questions[this.currentStep] || null;
      },

      get progressPercent() {
        if (this.totalSteps === 0) return 0;
        return Math.round(((this.currentStep) / this.totalSteps) * 100);
      },

      get selectedBox() {
        var sel = this.selected;
        return this.boxes.find(function(b) { return b.id === sel; }) || null;
      },

      // ── Init (countdown + observer) ──
      init() {
        var self = this;

        // Countdown (midnight reset)
        if (config.enableCountdown) {
          var midnight = new Date();
          midnight.setHours(24, 0, 0, 0);
          function tick() {
            var now = new Date();
            var diff = Math.floor((midnight - now) / 1000);
            if (diff <= 0) { midnight.setDate(midnight.getDate() + 1); diff = 86400; }
            var h = String(Math.floor(diff / 3600)).padStart(2, '0');
            var m = String(Math.floor((diff % 3600) / 60)).padStart(2, '0');
            var s = String(diff % 60).padStart(2, '0');
            self.timer = h + ':' + m + ':' + s;
          }
          tick();
          this._tid = setInterval(tick, 1000);
        }

        // Sticky CTA observer
        this.$nextTick(function() {
          var sentinel = document.getElementById('mbp-sentinel');
          if (!sentinel || !('IntersectionObserver' in window)) {
            self.stickyVisible = true;
            return;
          }
          self._obs = new IntersectionObserver(function(entries) {
            self.stickyVisible = !entries[0].isIntersecting;
          }, { threshold: 0 });
          self._obs.observe(sentinel);
        });
      },

      destroy() {
        clearInterval(this._tid);
        if (this._obs) this._obs.disconnect();
      },

      // ── Quiz navigation ──
      startQuiz() {
        this.screen = 'quiz';
        this.currentStep = 0;
        this.answers = [];
      },

      skipToSelect() {
        this.profile = {
          tags: [],
          exclusions: [],
          summary: 'Sorpresa total',
          style: '',
          occasion: '',
          projection: ''
        };
        this.screen = 'select';
      },

      answer: function(option) {
        this.answers[this.currentStep] = option;

        // Brief pause so the user sees their selection highlighted
        var self = this;
        var delay = this.currentStep < this.totalSteps - 1 ? 350 : 500;

        setTimeout(function() {
          if (self.currentStep < self.totalSteps - 1) {
            var next = self.currentStep + 1;
            self._stepChanging = true;
            self.$nextTick(function() {
              self.currentStep = next;
              self.$nextTick(function() { self._stepChanging = false; });
            });
          } else {
            self._buildProfile();
            self.screen = 'profile';
          }
        }, delay);
      },

      goBack: function() {
        if (this._stepChanging) return;
        if (this.currentStep > 0) {
          this._stepChanging = true;
          var self = this;
          this.$nextTick(function() {
            self.currentStep--;
            self.$nextTick(function() { self._stepChanging = false; });
          });
        } else {
          this.screen = 'landing';
        }
      },

      goToSelect: function() {
        this.screen = 'select';
      },

      retakeQuiz: function() {
        this.answers = [];
        this.currentStep = 0;
        this._stepChanging = false;
        this.screen = 'quiz';
      },

      selectBox: function(boxId) {
        this.selected = (this.selected === boxId) ? null : boxId;
      },

      selectSize: function(boxId, idx) {
        this.sizeIdx = Object.assign({}, this.sizeIdx, { [boxId]: idx });
      },

      getBoxSizeVariant: function(box) {
        if (!box || !box.sizes || box.sizes.length < 2) return null;
        var idx = this.sizeIdx[box.id] || 0;
        return box.sizes[idx] || box.sizes[0];
      },

      // ── Add to Cart con properties ──
      _adding: false,
      _added: false,

      addToCart: function() {
        var box = this.selectedBox;
        if (!box || !box.available || this._adding) return;

        // Use size variant if available, otherwise fall back to default
        var sizeVariant = this.getBoxSizeVariant(box);
        var variantId = (sizeVariant && sizeVariant.av) ? sizeVariant.id : box.variantId;
        if (variantId === 0) return;

        var props = {};
        if (this.profile.summary && this.profile.summary !== 'Sorpresa total') {
          props['Perfil Olfativo'] = this.profile.summary;
        }
        if (this.profile.exclusions.length > 0) {
          props['Exclusiones'] = this.profile.exclusions.join(', ');
        }
        if (this.profile.occasion) {
          props['Ocasion'] = this.profile.occasion;
        }
        if (this.profile.projection) {
          props['Proyeccion'] = this.profile.projection;
        }
        if (this.profile.style) {
          props['Estilo'] = this.profile.style;
        }

        var hasProps = Object.keys(props).length > 0;
        var self = this;
        this._adding = true;
        Alpine.store('cart').addItem(variantId, 1, hasProps ? props : undefined);
        // Brief success state
        setTimeout(function() {
          self._adding = false;
          self._added = true;
          setTimeout(function() { self._added = false; }, 2000);
        }, 600);
      },

      // ── Profile Builder ──
      _buildProfile: function() {
        var tags = [];
        var exclusions = [];
        var occasion = '';
        var projection = '';
        var style = '';

        for (var i = 0; i < this.answers.length; i++) {
          var ans = this.answers[i];
          if (!ans) continue;
          var q = this.questions[i];
          if (!q) continue;

          var opt = q.options.find(function(o) { return o.value === ans; });
          var label = (opt && opt.label) ? opt.label : ans;

          switch (q.category) {
            case 'attraction':
              tags.push(label);
              break;
            case 'occasion':
              occasion = label;
              tags.push(label);
              break;
            case 'projection':
              projection = label;
              tags.push(label);
              break;
            case 'exclusion':
              if (ans !== 'ninguna') {
                exclusions.push(label);
              }
              break;
            case 'style':
              style = label;
              tags.push(label);
              break;
            default:
              tags.push(label);
          }
        }

        var summaryParts = tags.filter(function(t) { return t; });
        this.profile = {
          tags: summaryParts,
          exclusions: exclusions,
          summary: summaryParts.join(' · '),
          style: style,
          occasion: occasion,
          projection: projection
        };
      }
    };
  });
});
